
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "Macintosh fonts named for R5 stops",
  "date": "2012-06-07 14",
  "comments": "true",
  "categories": "[\"apple\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2012-06-07",
  "tags": [
    "apple"
  ],
  "draft": false
}
  const body = {"type":"div","props":{},"children":[{"type":"p","props":{},"children":["In recent days, I've finally revisited Walter Isaacson's biography of Steve Jobs. To my surprise, I came across an excerpt about the font names for the first Macintosh."]},"\n",{"type":"blockquote","props":{},"children":["\n",{"type":"p","props":{},"children":["At the calligraphy class he had audited at Reed, Jobs learned to love typefaces, with all of their serif and sans serif variations, proportional spacing, and leading. “When we were designing the first Macintosh computer, it all came back to me,” he later said of that class. Because the Mac was bitmapped, it was possible to devise an endless array of fonts, ranging from the elegant to the wacky, and render them pixel by pixel on the screen.  "]},"\n"]},"\n",{"type":"p","props":{},"children":["More.. "]},"\n",{"type":"blockquote","props":{},"children":["\n",{"type":"p","props":{},"children":["To design these fonts, Hertzfeld recruited a high school friend from suburban Philadelphia, Susan Kare. They named the fonts after the stops on Philadelphia’s Main Line commuter train: Overbrook, Merion, Ardmore, and Rosemont. Jobs found the process fascinating.  "]},"\n"]},"\n",{"type":"p","props":{},"children":["And finally.."]},"\n",{"type":"blockquote","props":{},"children":["\n",{"type":"p","props":{},"children":["Late one afternoon he stopped by and started brooding about the font names. They were “little cities that nobody’s ever heard of,” he complained. “They ought to be world-class cities!” The fonts were renamed Chicago, New York, Geneva, London, San Francisco, Toronto, and Venice.  "]},"\n"]}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
